import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Layout from '../../../components/global/Layout';
import useCompanySummary from './hooks/useCompanySummary';
import useSearchCompanies from './hooks/useSearchCompanies';
import StatCards from './components/StatCards';
import FilterBar from './components/FilterBar';
import CompanyTable from './components/CompanyTable';
import DetailDrawer from './components/DetailDrawer';
import CompanyFormDrawer from './components/CompanyFormDrawer';

const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
`;

const PageTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #16110d;
`;

const NewCompanyBtn = styled.button`
  cursor: pointer;
  border: none;
  outline: none;
  border-radius: 8px;
  padding: 9px 16px;
  font-size: 13px;
  font-weight: 600;
  background: #f36e21;
  color: #fff;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: opacity 0.14s;
  &:hover {
    opacity: 0.88;
  }
`;

const CompanySummary = () => {
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [formOpen, setFormOpen] = useState(false);
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [drawerRefreshKey, setDrawerRefreshKey] = useState(0);

  const { summary, loading: summaryLoading } = useCompanySummary();
  const searchData = useSearchCompanies();

  const openNewCompany = () => {
    setEditingCompanyId(null);
    setFormOpen(true);
  };

  const openEditCompany = companyId => {
    // setSelectedCompany(null);
    setEditingCompanyId(companyId);
    setFormOpen(true);
  };

  const closeForm = () => {
    setFormOpen(false);
    setEditingCompanyId(null);
  };

  useEffect(() => {
    if (searchData.companies.length === 0) return;
    setSelectedCompany(prev => {
      if (!prev) return prev;
      return (
        searchData.companies.find(c => c.company_id === prev.company_id) ?? prev
      );
    });
  }, [searchData.companies]);

  const handleFormSuccess = () => {
    closeForm();
    searchData.refresh();
    setDrawerRefreshKey(k => k + 1);
  };

  return (
    <Layout>
      <div style={{ margin: '1rem' }}>
        <TopBar>
          <PageTitle>Company Management</PageTitle>
          <NewCompanyBtn onClick={openNewCompany}>+ New Company</NewCompanyBtn>
        </TopBar>
        <StatCards summary={summary} loading={summaryLoading} />
        <FilterBar
          nameSearch={searchData.nameSearch}
          setNameSearch={searchData.setNameSearch}
          placeIdFilter={searchData.placeIdFilter}
          setPlaceIdFilter={searchData.setPlaceIdFilter}
          statusFilter={searchData.statusFilter}
          setStatusFilter={searchData.setStatusFilter}
          stateFilter={searchData.stateFilter}
          setStateFilter={searchData.setStateFilter}
          abnStatusFilter={searchData.abnStatusFilter}
          setAbnStatusFilter={searchData.setAbnStatusFilter}
          bankStatusFilter={searchData.bankStatusFilter}
          setBankStatusFilter={searchData.setBankStatusFilter}
        />
        <CompanyTable
          companies={searchData.companies}
          totalSize={searchData.totalSize}
          totalPages={searchData.totalPages}
          loading={searchData.loading}
          error={searchData.error}
          listSize={searchData.listSize}
          pageFrom={searchData.pageFrom}
          setPageFrom={searchData.setPageFrom}
          currentPage={searchData.currentPage}
          setCurrentPage={searchData.setCurrentPage}
          sort={searchData.sort}
          setSort={searchData.setSort}
          onRowClick={setSelectedCompany}
          onEdit={openEditCompany}
        />
        {selectedCompany && (
          <DetailDrawer
            company={selectedCompany}
            onClose={() => setSelectedCompany(null)}
            onEdit={openEditCompany}
            refreshKey={drawerRefreshKey}
          />
        )}
        <CompanyFormDrawer
          key={editingCompanyId || 'new'}
          open={formOpen}
          companyId={editingCompanyId}
          onClose={closeForm}
          onSuccess={handleFormSuccess}
        />
      </div>
    </Layout>
  );
};

export default CompanySummary;
